<div class="d-flex jc-between p-y-10">
  <p class="text-20 f-w-400">Vincular comanda a mesa</p>
  <i-tabler name="x" class="icon-20 stroke-1 text-danger" (click)="close()" />
</div>

<div class="p-20">
  @if (inputMode === 'text') {
  <form class="w-100 m-y-10" [formGroup]="form" (ngSubmit)="handleBindTable()">
    <div class="row">
      <div class="col-12">
        <app-input-only-numbers maxlength="5" nameControl="BindedTableNumber" textLabel="Nº da mesa"
          [required]="true" />
      </div>
    </div>
    <button class="btn w-100 flat-button m-t-20" [disabled]="form.invalid" type="submit">
      Ok
    </button>
  </form>
  }

  @if (inputMode === 'qr') {
  <div class="w-100 m-t-10" style="max-width: 420px; margin: 0 auto">
    <app-qr-code-scanner #qrUi (decoded)="onTableQrDecoded($event)" />
  </div>
  }

  <div class="d-flex w-100 m-y-30 gap-10 jc-center">
    <button type="button" class=" btn d-flex jc-center ai-center p-12"
      [ngClass]="inputMode === 'text' ? 'flat-button' : 'stroked-button'" (click)="setInputMode('text')"
      aria-label="Digitar número">
      <i-tabler name="keyboard" class="icon-24 stroke-1" />
    </button>
    <button type="button" class=" btn d-flex jc-center ai-center p-12"
      [ngClass]="inputMode === 'qr' ? 'flat-button' : 'stroked-button'" (click)="setInputMode('qr')"
      aria-label="Ler QR Code">
      <i-tabler name="qrcode" class="icon-24 stroke-1" />
    </button>
  </div>
</div>